//目前ws地址
//export const websocketUrl = "";
let websocketUrl = "";
//websocket端口
let websocketPort = "9001";
//url前缀 测试
let baseUrl = "https://jzhongtech.com";
//let prefix = "/mng/HangZhou"; 
let prefix = "/mng/"; 
let netPrefix = 'https://jzhongtech.com/netwxapp'; //网关前缀
//本地测试
//let baseUrl = "http://127.0.0.1:53540";
//let prefix = "/";
let nfsprefix = '/testnfs';

// 导出变量供其他模块使用
export { baseUrl, prefix, netPrefix, nfsprefix, websocketUrl, websocketPort };
